const getPdpImagePath = ({
  deployEnv,
  fileName,
}: {
  deployEnv: string | undefined;
  fileName: string;
}): string => {
  // The public PDP hosts do not route /images/pdp to Cosmos.
  let origin = '';
  if (deployEnv === 'production') {
    origin = 'https://cosmos.apps.opendoor.com';
  } else if (deployEnv === 'staging' || deployEnv === 'qa') {
    origin = 'https://cosmos.apps-staging.opendoor.com';
  }

  return `${origin}/images/pdp/${fileName}`;
};

export const getPdpGuaranteeSealPath = (deployEnv: string | undefined): string =>
  getPdpImagePath({ deployEnv, fileName: 'guarantee-seal' });

// eslint-disable-next-line @opendoor/no-direct-env-check
const PDP_DEPLOY_ENV = process.env.NEXT_PUBLIC_DEPLOY_ENV;
const PDP_GUARANTEE_SEAL_PATH = getPdpGuaranteeSealPath(PDP_DEPLOY_ENV);
export const PDP_GUARANTEE_SEAL_URL = `${PDP_GUARANTEE_SEAL_PATH}@1x.png`;
export const PDP_SAVINGS_ARROW_URL = getPdpImagePath({
  deployEnv: PDP_DEPLOY_ENV,
  fileName: 'savings-arrow.svg',
});
export const PDP_GUARANTEE_SEAL_SRCSET = [
  { src: `${PDP_GUARANTEE_SEAL_PATH}@1x.png`, density: 1 },
  { src: `${PDP_GUARANTEE_SEAL_PATH}@2x.png`, density: 2 },
];
/** Browsers pick AVIF, then WebP, then the PNG fallback above. */
export const PDP_GUARANTEE_SEAL_SOURCES = [
  {
    type: 'image/avif',
    srcSet: [
      { src: `${PDP_GUARANTEE_SEAL_PATH}@1x.avif`, density: 1 },
      { src: `${PDP_GUARANTEE_SEAL_PATH}@2x.avif`, density: 2 },
    ],
  },
  {
    type: 'image/webp',
    srcSet: [
      { src: `${PDP_GUARANTEE_SEAL_PATH}@1x.webp`, density: 1 },
      { src: `${PDP_GUARANTEE_SEAL_PATH}@2x.webp`, density: 2 },
    ],
  },
];
